import { render, staticRenderFns } from "./MST_CO_MGMT.vue?vue&type=template&id=75a87dc2&scoped=true"
import script from "./MST_CO_MGMT.vue?vue&type=script&lang=ts"
export * from "./MST_CO_MGMT.vue?vue&type=script&lang=ts"
import style0 from "./MST_CO_MGMT.vue?vue&type=style&index=0&id=75a87dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a87dc2",
  null
  
)

export default component.exports